import { HashLink } from "react-router-hash-link";
import AnimatedArrow from "./AnimatedArrow";

export default function NavBar() {
  return (
    <div className="flex flex-row text-white items-center bg-[#1b1b1b] justify-between py-4 px-4 lg:px-12">
      <div className="flex flex-row gap-3">
        <img
          src={require("../assets/icons/calipsio_logo_white.png")}
          alt="calipsio icon"
          className="h-6"
        />
        <div className="text-2xl">Calipsio</div>
      </div>
      <div className="flex flex-row gap-8 items-center">
        <HashLink smooth to="#mission" className="hidden sm:block">
          <div className="cursor-pointer hover:opacity-80">Mission</div>
        </HashLink>
        <HashLink smooth to="#apps" className="hidden sm:block">
          <div className="cursor-pointer hover:opacity-80">Apps</div>
        </HashLink>
        <a
          href="mailto:contact@calips.io"
          className="group flex flex-row items-center p-2 gap-4 bg-white cursor-pointer transition-all hover:opacity-90"
        >
          <div className="text-black">Contact us</div>
          <AnimatedArrow color="black" />
        </a>
      </div>
    </div>
  );
}
